/**
 * @generated SignedSource<<b4efeb173a03d73c32b80d53e5160305>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisconnectActionItemIntegrationLinkInput = {
  blockKey: string;
  clientMutationId?: string | null;
  noteId: string;
};
export type actionItemUnlinkingModalMutation$variables = {
  input: DisconnectActionItemIntegrationLinkInput;
};
export type actionItemUnlinkingModalMutation$data = {
  readonly disconnectActionItemIntegrationLink: {
    readonly ok: boolean;
  } | null;
};
export type actionItemUnlinkingModalMutation = {
  response: actionItemUnlinkingModalMutation$data;
  variables: actionItemUnlinkingModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DisconnectActionItemIntegrationLinkPayload",
    "kind": "LinkedField",
    "name": "disconnectActionItemIntegrationLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "actionItemUnlinkingModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "actionItemUnlinkingModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b8204260e96edb10bd714810a8df3515",
    "id": null,
    "metadata": {},
    "name": "actionItemUnlinkingModalMutation",
    "operationKind": "mutation",
    "text": "mutation actionItemUnlinkingModalMutation(\n  $input: DisconnectActionItemIntegrationLinkInput!\n) {\n  disconnectActionItemIntegrationLink(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a8b4677c236aa6816bab2b02fed6da7";

export default node;
